"use strict";
/*
This file is part of web3.js.

web3.js is free software: you can redistribute it and/or modify
it under the terms of the GNU Lesser General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

web3.js is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Lesser General Public License for more details.

You should have received a copy of the GNU Lesser General Public License
along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateArgon2idParams = exports.ARGON2ID_BOUNDS = void 0;
exports.ARGON2ID_BOUNDS = {
    m: { min: 4096, max: 1048576 },
    t: { min: 2, max: 50 },
    p: { min: 1, max: 16 },
    dklen: { min: 16, max: 64 },
};
const isInt = (v) => typeof v === 'number' && Number.isInteger(v) && Number.isFinite(v);
const validateArgon2idParams = (params) => {
    const { m, t, p, dklen } = params;
    if (!isInt(m) || m < exports.ARGON2ID_BOUNDS.m.min || m > exports.ARGON2ID_BOUNDS.m.max) {
        throw new Error(`Argon2id m out of range [${exports.ARGON2ID_BOUNDS.m.min}, ${exports.ARGON2ID_BOUNDS.m.max}]`);
    }
    if (!isInt(t) || t < exports.ARGON2ID_BOUNDS.t.min || t > exports.ARGON2ID_BOUNDS.t.max) {
        throw new Error(`Argon2id t out of range [${exports.ARGON2ID_BOUNDS.t.min}, ${exports.ARGON2ID_BOUNDS.t.max}]`);
    }
    if (!isInt(p) || p < exports.ARGON2ID_BOUNDS.p.min || p > exports.ARGON2ID_BOUNDS.p.max) {
        throw new Error(`Argon2id p out of range [${exports.ARGON2ID_BOUNDS.p.min}, ${exports.ARGON2ID_BOUNDS.p.max}]`);
    }
    if (!isInt(dklen) ||
        dklen < exports.ARGON2ID_BOUNDS.dklen.min ||
        dklen > exports.ARGON2ID_BOUNDS.dklen.max) {
        throw new Error(`Argon2id dklen out of range [${exports.ARGON2ID_BOUNDS.dklen.min}, ${exports.ARGON2ID_BOUNDS.dklen.max}]`);
    }
};
exports.validateArgon2idParams = validateArgon2idParams;
//# sourceMappingURL=kdf_policy.js.map